var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressbar1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 4,
    viewBox: "0 0 150 4",
    fill: "none",
    id: "ProgressBar",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "progress-title"
  }, "5% completed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "progress-title"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 4,
    rx: 2,
    fill: "#EFEFEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ProgressBarMeter",
    d: "M0 2C0 0.895431 0.895431 0 2 0H3V4H2C0.895431 4 0 3.10457 0 2V2Z",
    fill: "#2E853F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressbar1);
export default __webpack_public_path__ + "static/media/progressbar1.ca380ab3b7689084090674b72c5a5262.svg";
export { ForwardRef as ReactComponent };